import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Pv2ModalPlayButtonComponent, Pv2StationHomePageController } from '@splixer/player-ui';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbsComponent } from '../../core/layout/breadcrumbs/breadcrumbs.component';
import { NowPlayerComponent } from '../../shared/playback/now-playing/now-player/now-player.component';
import { PSNotification, PSNotificationTypes } from '@hidat/huijs-player';
import { DeviceStoreService } from '@splixer/player';
import { KexpDialogsService } from '../../services/dialogs.service';

@Component({
  selector: 'station-home-page',
  templateUrl: 'kexp-home.page.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass, RouterOutlet,
    Pv2ModalPlayButtonComponent, BreadcrumbsComponent, NowPlayerComponent
  ]
})
export class StationHomePage extends Pv2StationHomePageController {
  protected deviceStore = inject(DeviceStoreService);
  protected dialogService = inject(KexpDialogsService);

  protected override onMixStarted() {
    //this.router.navigate(['/np', 'playlist']);
  }

  protected stationLoaded() {
    console.debug('Station loaded');
    if (!this.deviceStore.infoPanelDismissed) {
      this.dialogService.showGreeting();
      this.deviceStore.dismissInfoPanel();
    }
  }


  protected override handleNotification(notification: PSNotification) {
    if (!(notification.type === PSNotificationTypes.OUT_OF_CONTENT ||
      notification.type === PSNotificationTypes.ALMOST_OUT_OF_CONTENT ||
      notification.type === PSNotificationTypes.MIX_PLAYED_OUT)
    ) {
      super.handleNotification(notification);
    }
  }
}
